export default $axios => {   
    return {
        $axios,
        
        async fetch(query) {   
            return await $axios.get(`/messages${query}`); 
        },

        async send(form) { 
            return await $axios.post("/messages", form); 
        },

        async sendImage(form) {
            return await $axios.post("/messages/image", form); 
        }
    }; 
}; 
 